var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',_vm._b({staticClass:"panel"},'section',_vm.$attrs,false),[_c('button',{staticClass:"icon-button dismiss",on:{"click":function($event){return _vm.$emit('dismiss')}}},[_c('x-icon')],1),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }